const safeReturnTo = (value: string | null | undefined): string => {
  if (value == null || value === '') return '/';

  let decoded: string;
  try {
    decoded = decodeURIComponent(value);
  } catch {
    return '/';
  }

  // 制御文字 (Cc) / 書式文字 (Cf) / Surrogate (Cs) / 私用領域 (Co) / 未割当 (Cn) を拒否（Trojan Source / 視覚偽装対策）
  if (/\p{C}/u.test(decoded)) return '/';

  // 絶対 URL (`https:` / `javascript:` / `data:` 等) を拒否し相対パスのみ許可
  if (!decoded.startsWith('/')) return '/';

  // プロトコル相対 URL (`//host`) と一部ブラウザで外部扱いされる `/\host` を拒否
  if (decoded.startsWith('//') || decoded.startsWith('/\\')) return '/';

  return value;
};

export { safeReturnTo };
